import React from "react";
import MainInput from "../../../../atoms/Forms/MainInput";
import MainTextArea from "../../../../atoms/Forms/MainTextArea";
import MainButtonInput from "../../../../atoms/Forms/MainButtonInput";
import MainMoneyInput from "../../../../atoms/Forms/MainMoneyInput";
import LocalizationProductFilter from "views/Admin/Stock/LocalizationProduct/LocalizationProductFilter";
import LocalizationProductItem from "../../../../../../shared/components/LocalizationProductItem";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";

import styles from "./MainApp.organisms.Product.Details.FormEditProduct.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export class FormEditProduct extends React.Component {
  render() {
    const { product, handleChange, handleBlur, selectCategory, handleChangeRelatedItems, stock, errors } = this.props;
    const itemIds = product?.related_items?.map(el => el.id) || [];

    const handleSelectedItem = (item) => {
      if (!item) return;
      const product_selected = { "id": item.key, "name": item.label };
      const updatedRelatedItems = [...product.related_items, product_selected];
      handleChangeRelatedItems(updatedRelatedItems);
    }

    const handleDeleteItem = (itemId) => {
      const updatedRelatedItems = product.related_items.filter(item => String(item.id) !== String(itemId));
      handleChangeRelatedItems(updatedRelatedItems);
    }

    return (
      <div
        className={`${styles["form-edit-product-container"]} ${!product.enabled ? styles["disabled"] : ""}`}
        data-automation-id="form-edit-product-container"
      >
        <div className={styles["form-edit-product-header"]}>
          <div className={`${styles["form-edit-product-stock-label"]} ${stock > 0 ? styles["with-stock"] : styles["without-stock"]}`}>
              {stock > 0 ? 'Stock' : i18n.t("out.of.stock")}
            </div>
          {stock > 0 && <div className={styles["form-edit-product-stock-quantity"]} data-automation-id="form-edit-product-stock-quantity">{stock} {i18n.t("available")} <span>
            {/* <i className={`${styles["form-edit-product-icon"]} ${styles["icon-chevron-derecha"]}`}></i> */}
          </span></div>}
        </div>
        <div className={styles["form-edit-product-separator"]}></div>
        <div className={styles["form-edit-product-title"]}>{i18n.t("step.description")}</div>
        <div className={styles["form-edit-input-field"]}>
          <MainInput
            label={capitalize(i18n.t("code"))}
            required={true}
            id={"product-codigo"}
            name="sku"
            value={product.sku}
            handleChange={handleChange}
            error={errors['sku']}
            disabled
          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-name">
          <MainInput
            label={i18n.t("product.name")}
            required={true}
            id={"product-name"}
            name="name"
            value={product.name}
            handleChange={handleChange}
            error={errors['name']}
            maxLength={100}
          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-brand">
          <MainInput
            label={capitalize(i18n.t("brand"))}
            required={true}
            id={"product-brand"}
            name="brand"
            value={product.brand}
            handleChange={handleChange}
            error={errors['brand_name']}
            maxLength={50}
          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-description">
          <MainTextArea
            label={capitalize(i18n.t("description"))}
            id={"product-description"}
            name="description"
            value={product.description}
            handleChange={handleChange}
            error={errors['description']}
            maxLength={255}
          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-category">
          <MainButtonInput
            label={capitalize(i18n.t("category"))}
            id={"product-category"}
            value={product.category ? product.category.name : null}
            handleClick={selectCategory}
            error={errors['categories']}
            maxLength={50}
          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-purchase-price">
          <MainMoneyInput
            label={i18n.t("purchase_price")}
            id={"product-buyng-price"}
            name="purchase_price"
            value={product.purchase_price}
            handleChange={handleChange}
            handleBlur={handleBlur}
            error={errors['purchase_price']}
            maxLength={15}
            />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-selling-price">
          <MainMoneyInput
            label={capitalize(i18n.t("sell_price"))}
            id={"product-selling-price"}
            name="sell_price"
            value={product.sell_price}
            handleChange={handleChange}
            handleBlur={handleBlur}
            error={errors['sell_price']}
            maxLength={15}
            />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-weight">
          <MainInput
            label={capitalize(i18n.t("weight"))+" (kg)"}
            id={"product-weight"}
            name="weight"
            value={product.weight}
            handleChange={handleChange}
            handleBlur={handleBlur}
            maxLength={100}
            error={errors.weight}
            type="number"

          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-measure-depth">
          <MainInput
            label={capitalize(i18n.t("measure_depth"))+" (cm)"}
            id={"product-measure-depth"}
            name="measure_depth"
            value={product.measure_depth}
            handleChange={handleChange}
            handleBlur={handleBlur}
            maxLength={100}
            error={errors.measure_depth}
            type="number"

          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-measure-height">
          <MainInput
            label={capitalize(i18n.t("measure_height"))+" (cm)"}
            id={"product-measure-height"}
            name="measure_height"
            value={product.measure_height}
            handleChange={handleChange}
            handleBlur={handleBlur}
            maxLength={100}
            error={errors.measure_height}
            type="number"

          />
        </div>
        <div className={styles["form-edit-input-field"]} data-automation-id="input-measure-width">
          <MainInput
            label={capitalize(i18n.t("measure_width"))+" (cm)"}
            id={"product-measure-width"}
            name="measure_width"
            value={product.measure_width}
            handleChange={handleChange}
            handleBlur={handleBlur}
            maxLength={100}
            error={errors.measure_width}
            type="number"

          />
        </div>
        <div className={styles["outter-wrapper"]}>
          <label className={styles["form-edit-product-title"]}>
            {i18n.t("related.items")}
          </label>

          <div className={styles["inner-wrapper"]}>
            <Container className={styles["container-localization-products"]}>
              <LocalizationProductFilter handleApply={handleSelectedItem} />
              <div className={styles["product-search-wrapper"]}>
                {itemIds.map(element => (
                  <div className={styles["grid-wrapper"]} key={element}>
                    <Grid className={styles["grid-container"]}>
                      <div className={styles["localization-product-item"]}>
                        <LocalizationProductItem key="element" itemId={element} />
                        <i
                          className={`${styles["icon-iconos_eliminar"]} icon-iconos_eliminar`}
                          onClick={() => handleDeleteItem(element)}
                        />
                      </div>
                    </Grid>
                  </div>
                ))}
              </div>
            </Container>
          </div>
        </div>

        {!product.enabled && <div className={styles["form-edit-overlay"]}></div>}
      </div>
    );
  }
}

export default FormEditProduct;
